//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../Features/Features.ShipDesign.ManufacturingStockBuilder.js";
import "../no/SelectBodyList.js";
import "../no/SelectEdgeList.js";
import "../Features/Features.ShipDesign.SteelFeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"ArrowHeadAngle",0,"Expression",0],[1,"ArrowHeadHeight",0,"Expression",0],[1,"ArrowHeight",0,"Expression",0],[0,"DirectionOption",1,0],[0,"DistanceTolerance",1,0],[1,"GuideCurve",0,"SelectNXObject",0],[1,"GuideCurveList",0,"SelectNXObjectList",0],[1,"LeftOffsetDistance",0,"Expression",0],[1,"ManufacturingInformation",0,"Features.ShipDesign.ManufacturingStockBuilder",0],[0,"PlacementType",1,0],[1,"RightOffsetDistance",0,"Expression",0],[1,"ShipStructure",0,"SelectBodyList",0],[1,"ShipStructureEdge",0,"SelectEdgeList",0],[1,"Spreadsheet",0,"Features.ShipDesign.SteelFeatureSpreadsheetBuilder",0],[0,"WaterStopOffsetOption",1,0],[1,"WaterStopShape",0,"SelectNXObject",0],[1,"WaterStopShapeList",0,"SelectNXObjectList",0]],[],[]];
SPLM.Features.ShipDesign.AlongGuideCutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.AlongGuideCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.AlongGuideCutBuilder.CreationMethod = Object.freeze({
    "WeldClearance" : "WeldClearance", "WaterStop" : "WaterStop", "EggBoxTop" : "EggBoxTop", "EggBoxBottom" : "EggBoxBottom", "EggBox" : "EggBox", "Notch" : "Notch"});

SPLM.Features.ShipDesign.AlongGuideCutBuilder.WaterStopOffsetMethod = Object.freeze({
    "Symmetric" : "Symmetric", "Asymmetric" : "Asymmetric"});

SPLM.Features.ShipDesign.AlongGuideCutBuilder.DirectionMethod = Object.freeze({
    "PerpendicularToMoldFace" : "PerpendicularToMoldFace", "AlongGuide" : "AlongGuide"});

export default SPLM;